module.exports = __webpack_public_path__ + "assets/img/cardItem02.b198dbf5.png";